import React from 'react';
import toTitleCase from '|/helpers/to-title-case';

// Mixed children like `Edit {isPickup ? 'pickup' : 'delivery'}` arrive as an
// array, so string parts are title-cased via Children.map rather than a single
// typeof check.
const titleCaseChildren = (children: React.ReactNode): React.ReactNode => {
  if (typeof children === 'string') return toTitleCase(children);
  return React.Children.map(children, child =>
    typeof child === 'string' ? toTitleCase(child) : child
  );
};

export default titleCaseChildren;
